import type { ChangeEvent } from "react";

import { TextField, type TextFieldProps } from "../../design-system";

export interface TextInputProps extends TextFieldProps {
  onValueChange?: (value: string) => void;
}

export function TextInput({
  onChange,
  onValueChange,
  ...props
}: TextInputProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
    onValueChange?.(event.target.value);
  };
  return <TextField {...props} onChange={handleChange} />;
}
